import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { NavLink } from 'react-router-dom'


function Contact() {

  return (
    <>
      <section className="section-breadcrumb">
        <div className="top_outline_01"></div>
        <div className="top_outline_02"></div>
        <div className="bottom_outline_01"></div>
        <div className="bottom_outline_02"></div>
        <div className="container-fulid">
          <div className="row">
            <div className="col-12">
              <div className="zx-breadcrumb padding-tb-100">
                <div className="banner mb-15 justify-content-center">
                  <h2>Contact Us</h2>
                </div>
                <div className="entry-breadcrumb">
                  <h5>
                    <span>
                      <NavLink to="/">Home</NavLink>
                    </span>
                    <span> / </span>
                    <span className="post-page">
                      <NavLink to="/contact">Contact Us</NavLink>
                    </span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-contact padding-tb-100">
        <div className="container">
          <div className="row">
            <Fade triggerOnce duration={1000} direction='up' className="col-lg-6 col-sm-12">
              <div className="row">
                <>

                  <div className="col-lg-6 col-sm-12">
                    <input type="text" className="form-control shadow-none" placeholder="First Name" />
                    <input type="email" className="form-control shadow-none" placeholder="E-mail" />
                  </div>
                  <div className="col-lg-6 col-sm-12 control-input">
                    <input type="text" className="form-control shadow-none" placeholder="Last Name" />
                    <input type="text" className="form-control shadow-none" placeholder="phone" />
                  </div>
                  <div className="col-12">
                    <textarea className="form-control shadow-none" placeholder="Message"></textarea>
                  </div>
                  <div className="col-12">
                    <div className="zx-button">
                      <button type="button" className="btn-small result-placeholder">Submit Now</button>
                    </div>
                  </div>
                </>

              </div>

            </Fade>
            <Fade triggerOnce duration={1000} direction='up' className="col-lg-6 col-sm-12" data-aos="fade-up" data-aos-duration="1500">
              <>
                <div className="map_info">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29749.225774882685!2d72.84343101893258!3d21.245595574425934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f4fb5c0b087%3A0xb7aabd8a90da0679!2sMota%20Varachha%2C%20Surat%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1690017805909!5m2!1sen!2sin"
                    className="w-100" loading="lazy" title="Google Maps" height="310" style={{ border: 0 }}></iframe>
                </div>
              </>
            </Fade>
          </div>
        </div>
      </section>
    </>

  )
}

export default Contact
